import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Tabs, Chip, Modal, Person, Pager, fmt, when } from "./kit";

const typeChip = (t) =>
  ({
    load: <Chip>Stok yüklendi</Chip>,
    deduct: <Chip kind="wait">Stok düşüldü</Chip>,
    send: <Chip kind="info">Gönderildi</Chip>,
  }[t] || t);

const CoinBank = () => {
  const [tab, setTab] = useState("sellers");
  const [data, setData] = useState({ sellers: [], totals: { balance: 0, loaded: 0, sent: 0 } });
  const [loading, setLoading] = useState(true);
  const [add, setAdd] = useState(null);
  const [bal, setBal] = useState(null);
  const [web, setWeb] = useState(null);
  const [msg, setMsg] = useState("");

  // hareket filtresi
  const [f, setF] = useState({ sellerId: "", code: "", type: "", from: "", to: "", page: 1 });
  const [tx, setTx] = useState({ txs: [], total: 0, sum: [] });

  const loadSellers = useCallback(async () => {
    setLoading(true);
    const r = await api.coinSellers();
    if (r?.status) setData(r);
    setLoading(false);
  }, []);

  const loadTx = useCallback(async () => {
    setLoading(true);
    const r = await api.coinTxs(f);
    if (r?.status) setTx(r);
    setLoading(false);
  }, [f]);

  useEffect(() => {
    if (tab === "sellers") loadSellers();
    else loadTx();
  }, [tab, loadSellers, loadTx]);

  const flash = (m) => {
    setMsg(m);
    setTimeout(() => setMsg(""), 4000);
  };

  const create = async () => {
    const r = await api.coinSellerCreate({ code: add.code, pin: add.pin, note: add.note });
    if (!r?.status) return window.alert(r?.message || "Eklenemedi");
    if (Number(add.amount) > 0) {
      await api.coinSellerBalance(r.seller._id, { type: "load", amount: Number(add.amount), note: "İlk stok" });
    }
    setAdd(null);
    flash("Bayi eklendi");
    loadSellers();
  };

  const saveBalance = async () => {
    const r = await api.coinSellerBalance(bal.seller._id, { type: bal.type, amount: Number(bal.amount), note: bal.note });
    if (!r?.status) return window.alert(r?.message || "İşlem başarısız");
    setBal(null);
    flash(r.message);
    loadSellers();
  };

  const toggle = async (s) => {
    if (!window.confirm(s.isActive ? `${s.name} bayiliği askıya alınsın mı?` : `${s.name} bayiliği açılsın mı?`)) return;
    const r = await api.coinSellerUpdate(s._id, { isActive: !s.isActive });
    if (!r?.status) return window.alert(r?.message || "İşlem başarısız");
    loadSellers();
  };

  const resetPin = async (s) => {
    const pin = window.prompt("Yeni 6 haneli PIN:", "");
    if (pin === null) return;
    const r = await api.coinSellerUpdate(s._id, { pin });
    window.alert(r?.message || (r?.status ? "PIN değişti" : "Değiştirilemedi"));
  };

  // web sitesi coin sayfasi (badulive.online/coin): bayi orada WhatsApp ile gorunur
  const saveWeb = async () => {
    const { seller, ...body } = web;
    const r = await api.coinSellerUpdate(seller._id, { ...body, webOrder: Number(body.webOrder) || 0 });
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    setWeb(null);
    flash("Site ayarı kaydedildi");
    loadSellers();
  };

  const sumOf = (t) => tx.sum?.find((x) => x._id === t) || { amount: 0, count: 0 };

  return (
    <>
      <PageHead
        title="Yetkili Bayi"
        sub="Yetkili bayiler, stokları ve kime ne gönderdikleri."
        right={
          <div className="d-flex align-items-center" style={{ gap: 10 }}>
            {msg && <span style={{ fontSize: 13, color: "#059669" }}>{msg}</span>}
            <button className="btn btn-primary" onClick={() => setAdd({ code: "", pin: "", amount: "", note: "" })}>
              Bayi ekle
            </button>
          </div>
        }
      />
      <Tiles
        items={[
          { label: "Bayi sayısı", value: fmt(data.sellers.length) },
          { label: "Bayilerdeki stok", value: fmt(data.totals.balance) },
          { label: "Toplam yüklenen", value: fmt(data.totals.loaded) },
          { label: "Kullanıcılara gönderilen", value: fmt(data.totals.sent) },
        ]}
      />
      <Tabs
        tabs={[
          ["sellers", "Bayiler"],
          ["txs", "Hareketler"],
        ]}
        value={tab}
        onChange={setTab}
      />

      {tab === "sellers" ? (
        <Table
          loading={loading}
          empty="Henüz yetkili bayi yok. Sağ üstten ID ile ekle."
          head={["Bayi", "ID", "Stok", "Yüklenen", "Gönderilen", "Durum", ""]}
          rows={data.sellers.map((s) => (
            <tr key={s._id}>
              <td>
                <Person image={s.image} name={s.name} />
                {s.note && <div style={{ fontSize: 12, color: "#6B7280" }}>{s.note}</div>}
              </td>
              <td>
                <code>{s.uniqueID}</code>
              </td>
              <td>
                <b>{fmt(s.balance)}</b>
              </td>
              <td>{fmt(s.totalLoaded)}</td>
              <td>{fmt(s.totalSent)}</td>
              <td>{s.isActive ? <Chip>Aktif</Chip> : <Chip kind="bad">Askıda</Chip>}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                <button className="btn btn-sm btn-success mr-1" onClick={() => setBal({ seller: s, type: "load", amount: "", note: "" })}>
                  Yükle
                </button>
                <button className="btn btn-sm btn-outline-secondary mr-1" onClick={() => setBal({ seller: s, type: "deduct", amount: "", note: "" })}>
                  Düş
                </button>
                <button
                  className="btn btn-sm btn-outline-primary mr-1"
                  onClick={() => {
                    setF({ sellerId: s._id, code: "", type: "", from: "", to: "", page: 1 });
                    setTab("txs");
                  }}
                >
                  Hareketler
                </button>
                <button
                  className={`btn btn-sm mr-1 ${s.showOnWeb ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setWeb({ seller: s, showOnWeb: !!s.showOnWeb, whatsapp: s.whatsapp || "", webRegion: s.webRegion || "tr", webInfo: s.webInfo || "", webOrder: s.webOrder || 0, webName: s.webName || "" })}
                >
                  {s.showOnWeb ? "Sitede ✓" : "Site"}
                </button>
                <button className="btn btn-sm btn-outline-secondary mr-1" onClick={() => resetPin(s)}>
                  PIN
                </button>
                <button className={`btn btn-sm ${s.isActive ? "btn-outline-danger" : "btn-outline-success"}`} onClick={() => toggle(s)}>
                  {s.isActive ? "Askıya al" : "Aç"}
                </button>
              </td>
            </tr>
          ))}
        />
      ) : (
        <>
          <div className="card">
            <div className="card-body d-flex flex-wrap align-items-end" style={{ gap: 10 }}>
              <div>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Bayi</label>
                <select className="form-control" value={f.sellerId} onChange={(e) => setF({ ...f, sellerId: e.target.value, page: 1 })}>
                  <option value="">Tümü</option>
                  {data.sellers.map((s) => (
                    <option key={s._id} value={s._id}>
                      {s.name} ({s.uniqueID})
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Alıcı / bayi ID</label>
                <input className="form-control" value={f.code} placeholder="ör. 2568689" onChange={(e) => setF({ ...f, code: e.target.value, page: 1 })} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Tür</label>
                <select className="form-control" value={f.type} onChange={(e) => setF({ ...f, type: e.target.value, page: 1 })}>
                  <option value="">Tümü</option>
                  <option value="send">Gönderilen</option>
                  <option value="load">Stok yüklenen</option>
                  <option value="deduct">Stok düşülen</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Başlangıç</label>
                <input className="form-control" type="date" value={f.from} onChange={(e) => setF({ ...f, from: e.target.value, page: 1 })} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Bitiş</label>
                <input className="form-control" type="date" value={f.to} onChange={(e) => setF({ ...f, to: e.target.value, page: 1 })} />
              </div>
              <div style={{ marginLeft: "auto", fontSize: 13, color: "#374151" }}>
                Gönderilen: <b>{fmt(sumOf("send").amount)}</b> ({sumOf("send").count} işlem) · Yüklenen: <b>{fmt(sumOf("load").amount)}</b>
              </div>
            </div>
          </div>
          <Table
            loading={loading}
            empty="Bu filtreyle hareket yok."
            head={["Tarih", "Tür", "Bayi", "Alıcı", "Miktar", "Kalan stok", "Not"]}
            rows={tx.txs.map((t) => (
              <tr key={t._id}>
                <td style={{ whiteSpace: "nowrap" }}>{when(t.createdAt)}</td>
                <td>{typeChip(t.type)}</td>
                <td>
                  {t.sellerName} <code>{t.sellerUniqueID}</code>
                </td>
                <td>
                  {t.type === "send" ? (
                    <>
                      {t.toName} <code>{t.toUniqueID}</code>
                    </>
                  ) : (
                    <span style={{ color: "#6B7280" }}>Admin</span>
                  )}
                </td>
                <td>
                  <b style={{ color: t.type === "send" ? "#1D4ED8" : t.type === "load" ? "#059669" : "#B45309" }}>
                    {t.type === "load" ? "+" : "−"}
                    {fmt(t.amount)}
                  </b>
                </td>
                <td>{fmt(t.balanceAfter)}</td>
                <td style={{ fontSize: 12, color: "#6B7280" }}>{t.note}</td>
              </tr>
            ))}
          />
          <Pager page={f.page} size={50} total={tx.total} onChange={(p) => setF({ ...f, page: p })} />
        </>
      )}

      <Modal open={!!add} title="Yetkili bayi ekle" onClose={() => setAdd(null)}>
        {add && (
          <>
            <label style={{ fontSize: 12, color: "#6B7280" }}>Kullanıcı ID</label>
            <input className="form-control" value={add.code} placeholder="Uygulamadaki ID" onChange={(e) => setAdd({ ...add, code: e.target.value })} />
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Gönderim PIN'i (6 hane — bayiye ilet)</label>
            <input
              className="form-control"
              inputMode="numeric"
              maxLength={6}
              value={add.pin}
              onChange={(e) => setAdd({ ...add, pin: e.target.value.replace(/\D/g, "") })}
            />
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Başlangıç stoğu (coin, isteğe bağlı)</label>
            <input className="form-control" type="number" min="0" value={add.amount} onChange={(e) => setAdd({ ...add, amount: e.target.value })} />
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Not</label>
            <input className="form-control" value={add.note} placeholder="ör. İstanbul bayisi" onChange={(e) => setAdd({ ...add, note: e.target.value })} />
            <div className="d-flex justify-content-end" style={{ gap: 8, marginTop: 16 }}>
              <button className="btn btn-outline-secondary" onClick={() => setAdd(null)}>
                Vazgeç
              </button>
              <button className="btn btn-primary" disabled={!add.code || add.pin.length !== 6} onClick={create}>
                Bayi yap
              </button>
            </div>
          </>
        )}
      </Modal>

      <Modal open={!!web} title="Web sitesinde göster (badulive.online/coin)" onClose={() => setWeb(null)}>
        {web && (
          <>
            <div style={{ marginBottom: 10 }}>
              <Person image={web.seller.image} name={web.seller.name} />
            </div>
            <label className="d-flex align-items-center" style={{ gap: 8, fontSize: 14, fontWeight: 600 }}>
              <input type="checkbox" checked={web.showOnWeb} onChange={(e) => setWeb({ ...web, showOnWeb: e.target.checked })} />
              Coin sayfasında yetkili bayi olarak göster
            </label>
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Sitede görünen ad (boş: hesap adı)</label>
            <input className="form-control" maxLength={30} value={web.webName} placeholder={web.seller.name} onChange={(e) => setWeb({ ...web, webName: e.target.value })} />
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>WhatsApp numarası (ülke koduyla, ör. 905321234567)</label>
            <input className="form-control" inputMode="tel" value={web.whatsapp} onChange={(e) => setWeb({ ...web, whatsapp: e.target.value.replace(/[^\d+ ]/g, "") })} />
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Sekme</label>
            <select className="form-control" value={web.webRegion} onChange={(e) => setWeb({ ...web, webRegion: e.target.value })}>
              <option value="tr">Türkiye</option>
              <option value="ar">Arap ülkeleri</option>
              <option value="other">Diğer</option>
            </select>
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Kısa bilgi (ör. Havale, Papara · 7/24)</label>
            <input className="form-control" maxLength={60} value={web.webInfo} onChange={(e) => setWeb({ ...web, webInfo: e.target.value })} />
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Sıra (küçük olan önce)</label>
            <input className="form-control" type="number" min="0" value={web.webOrder} onChange={(e) => setWeb({ ...web, webOrder: e.target.value })} />
            <div className="d-flex justify-content-end" style={{ gap: 8, marginTop: 16 }}>
              <button className="btn btn-outline-secondary" onClick={() => setWeb(null)}>
                Vazgeç
              </button>
              <button className="btn btn-primary" onClick={saveWeb}>
                Kaydet
              </button>
            </div>
          </>
        )}
      </Modal>

      <Modal open={!!bal} title={bal?.type === "load" ? "Bayi stoğuna coin yükle" : "Bayi stoğundan coin düş"} onClose={() => setBal(null)}>
        {bal && (
          <>
            <div style={{ marginBottom: 10 }}>
              <Person image={bal.seller.image} name={bal.seller.name} />
              <div style={{ fontSize: 13, color: "#6B7280", marginTop: 4 }}>
                Mevcut stok: <b>{fmt(bal.seller.balance)}</b>
              </div>
            </div>
            <label style={{ fontSize: 12, color: "#6B7280" }}>Miktar (coin)</label>
            <input className="form-control" type="number" min="1" value={bal.amount} onChange={(e) => setBal({ ...bal, amount: e.target.value })} />
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Not (ör. ödeme dekontu)</label>
            <input className="form-control" value={bal.note} onChange={(e) => setBal({ ...bal, note: e.target.value })} />
            <div className="d-flex justify-content-end" style={{ gap: 8, marginTop: 16 }}>
              <button className="btn btn-outline-secondary" onClick={() => setBal(null)}>
                Vazgeç
              </button>
              <button className={`btn ${bal.type === "load" ? "btn-success" : "btn-danger"}`} disabled={!(Number(bal.amount) > 0)} onClick={saveBalance}>
                {bal.type === "load" ? "Yükle" : "Düş"}
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default CoinBank;
